








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryMengBeanSummaryList,ExportMengBeanSummary} from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class MengBeanSummaryList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    statDateDaterange:[],
    orderBy: 'stat_date desc',
    statDateTimeScope:'',
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  // 数据表头 -
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '统计日期', param: 'statDate',width:120 },
    { title: '绿豆总额', param: 'totalMengBean' },
    { title: '期初绿豆', param: 'beginMengBean' },
    { title: '期末绿豆', param: 'endMengBean' },
    { title: '变更绿豆', param: 'dayChangeMengBean' },
    { title: '绿豆消费', param: 'mengBeanConsume' },
    { title: '绿豆退货', param: 'mengBeanRefund' },
    { title: '绿豆充值', param: 'mengBeanRecharge' },
    { title: '绿豆扣减', param: 'mengBeanDeduct' },
    { title: '绿豆补贴', param: 'mengBeanSubsidy' },
    { title: '绿豆对冲', param: 'mengBeanHedge' },
    { title: '店铺推荐', param: 'mengBeanShopRec' },
    { title: '区域代理', param: 'mengBeanAreaAgent' },
    { title: '系统恢复', param: 'mengBeanSysRestore' },
    { title: '区代', param: 'mengBeanDistAgent' },
    { title: '市代', param: 'mengBeanCityAgent' },
    { title: '省代', param: 'mengBeanProvAgent' },
    { title: '其他', param: 'mengBeanOther' },

    { title: '数据更新时间', param: 'updateTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      fixed: 'right',
      operation: [
        { title: '查看明细', click: this.jumpTo },
      ],
    },
  ]

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }
  private exportHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportMengBeanSummary(param,"每日绿豆数据统计.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  private jumpTo(data: any){
    // 跳转到数据源，用户积分记录，加入查询条件，和查询一直
    this.$router.push({
      path: "/userWealthRecordList",
      query:{
        finishTime: data.statDate,
        type: '3'
      }
    })
  }

  public async created() {
    this.loadData()
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryMengBeanSummaryList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length >0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
